import styled from "styled-components";

const EditCompanyPageWrap = styled.div`
    height: 100vh;
    background: #FFFF;
`;

export {
    EditCompanyPageWrap
}